<template>
  <p>{{ responseError }}</p>
  <form @submit.prevent = "logIn">
  <div class="form-group">
    <label for="email">Email address</label>
    <input type="email" v-model="form.email" class="form-control" id="email"  placeholder="Enter email">
  </div>
  <div class="form-group">
    <label for="password">Password</label>
    <input type="password" v-model="form.password" class="form-control"  placeholder="Password">
  </div>
  
  <button type="submit" class="btn btn-primary">Submit</button>
</form>
    
</template>

<script setup>
  
  import axios from "axios";
  import { reactive, ref } from "vue";
  import { useRoute, useRouter } from "vue-router";

  const router = useRouter();

  const route = useRoute();


  const form = reactive({
    email : '',
    password:'' 
  });

  const responseError = ref(null);

  async function logIn(){

    if(localStorage.getItem('authToken')){
      router.push('/user/admin');
    }

    try {
      const result = await axios.post('api/users/login', form);
      localStorage.setItem('authToken', result.data.token);
      router.push(route.query.redirect || '/user/admin');
    } catch (error) {
      responseError.value = error.response.data.message;
    }
    

   

    

  } 


</script>